/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';

/**
 * 
 * @export
 * @interface GetHarmfulFactorTestDto
 */
export interface GetHarmfulFactorTestDto {
    /**
     * 
     * @type {string}
     * @memberof GetHarmfulFactorTestDto
     */
    id: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetHarmfulFactorTestDto
     */
    test: GetTestDto;
}

/**
 * Check if a given object implements the GetHarmfulFactorTestDto interface.
 */
export function instanceOfGetHarmfulFactorTestDto(value: object): value is GetHarmfulFactorTestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('test' in value) || value['test'] === undefined) return false;
    return true;
}

export function GetHarmfulFactorTestDtoFromJSON(json: any): GetHarmfulFactorTestDto {
    return GetHarmfulFactorTestDtoFromJSONTyped(json, false);
}

export function GetHarmfulFactorTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHarmfulFactorTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'test': GetTestDtoFromJSON(json['test']),
    };
}

export function GetHarmfulFactorTestDtoToJSON(value?: GetHarmfulFactorTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'test': GetTestDtoToJSON(value['test']),
    };
}

